import { render, staticRenderFns } from "./signedtochange.vue?vue&type=template&id=4315ae6e&scoped=true"
import script from "./signedtochange.vue?vue&type=script&lang=js"
export * from "./signedtochange.vue?vue&type=script&lang=js"
import style0 from "./signedtochange.vue?vue&type=style&index=0&id=4315ae6e&prod&lang=scss&scoped=true"
import style1 from "./signedtochange.vue?vue&type=style&index=1&id=4315ae6e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4315ae6e",
  null
  
)

export default component.exports